export const EXPERIENCE_TEMPLATE_TYPE = 1;
export const PROCESSING_FLOW_TEMPLATE_TYPE = 2;
